

























































import {Component, Prop, Mixins} from 'vue-property-decorator';
import UserMixin from '../../../mixins/UserMixin';
import UserIcon from '../../common/UserIcon.vue';
import MessageIcon from '../../../assets/svg/message.svg'
import {EventBus} from '@common/EventBus'
import {detectMob} from "../../../common/mobileHelper";
import {IsMeetingsEnabled} from "../../../mixins/isMeetingsEnabled";
import {IsChatEnabled} from "../../../mixins/isChatEnabled";
import {UserProfile} from "@api/models/UserProfile";
import { PaymentAccess } from "../../../mixins/PaymentAccess";
import { TooltipDirective } from '@share/directives/Tooltip';

@Component({
    components: { UserIcon, MessageIcon },
    directives: { TooltipDirective }
})
export default class ParticipantTable extends Mixins(IsMeetingsEnabled, IsChatEnabled, UserMixin, PaymentAccess) {

    @Prop({ required: true }) fields: any;
    @Prop({ required: true }) source: UserProfile;
    @Prop({ default: {}}) tagsTexts: Record<number, string>;

    get tagsText() {
        return this.tagsTexts[this.source.userId as number] ?? '';
    }

    select(user: UserProfile) {
        if (this.$store.getters['userId'] !== user.userId) {
            EventBus.$emit("showChatByUserId", user.userId);
        }
    }

    isMobile() {
        return detectMob();
    }

    message() {
        if(this.showPayButtonInsteadChat) {
            this.showPayMessage();
            return
        }
        EventBus.$emit('messageTo', this.source.userId);
    }

    toEditUser(profile: UserProfile) {
        this.$emit('edit', profile);
    }

    createMeeting() {
        if(this.showPayButtonInsteadMeetings) {
            this.showPayMessage();
            return;
        }

        EventBus.$emit('createMeetingWith', this.source.userId);
    }

    get isAdmin(): boolean {
      return this.$store.getters['isAdmin'];
    }

    get isOnEditing() {
        return this.$store.state.isOnEditing;
    }

    get showButtons(): boolean {
        return this.$store.state.session.userId != this.source?.userId;
    }
}
